export class ListItem {
    constructor(
        public value: string,
        public text: string
    ) {}

    /**
     * Retourne une nouvelle instance de liste d'elements à partir d'une instance de liste d'elements.
     * @param other : Instance de la liste d'elements.
     * @returns : Instance de la liste d'elements.
     */
    public static from(other: ListItem) {
        if (!!other) {
            const instance = new ListItem(other.value, other.text);

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne un tableau d'instances de liste d'elements à partir d'un tableau d'instances de liste d'elements.
     * @param other : Tableau d'instances de liste d'elements.
     * @returns : Tableau d'instances de liste d'elements.
     */
    public static fromArray(others: ListItem[]) {
        if (!!others) {
            let listItems: ListItem[] = [];

            others.forEach((x) => {
                const listItem = ListItem.from(x);
                listItems.push(listItem);
            });

            return listItems;
        } else {
            return null;
        }
    }
}
